import React from 'react';

function Footer(){
    const date = new Date().getFullYear();
    return (
        <div className="footer text-center">{date}© geltonastraliukas.lt Visos teisės saugomos. </div>
    )
}

export default Footer;